import React, { useState, useEffect } from "react";

export function InputSelect({
    title,
    value,
    options,
    optionsValues,
    onChange,
    width,
    addClass,
    children,
    disabled=false,
    style={},
}) {
    const [selected, setSelected] = useState(value || null);

    function handleChange(e) {
        setSelected(e.target.value);
        onChange(e.target.value);
    }

    return (
        <div className="input-group">
            {title && <label>{title}</label>}

            <div className="input-select-wrapper" style={{ position: 'relative' }}>
                <select
                    // disabled={this.props.adevices.length < 2}
                    onChange={handleChange}
                    className={`small outline${addClass ? " " + addClass : ""}`}
                    value={selected}
                    style={{ width: width || '100%', ...style }}
                    disabled={disabled}
                >
                    {options.map((o, i) => (
                        <option
                            value={optionsValues ? optionsValues[i] : typeof o === 'object' && o._id ? o._id : ""}
                            key={i} 
                        >
                            {typeof o === 'object' && o.title ? o.title : 
                            typeof o === 'object' && o.name ? o.name : o}
                        </option>
                    ))}
                </select>
                {children}
            </div>
        </div>
    );
}
